import { render, staticRenderFns } from "./howItWorks.vue?vue&type=template&id=f609322a&"
import script from "./howItWorks.vue?vue&type=script&lang=ts&"
export * from "./howItWorks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports